module.exports = __webpack_public_path__ + "img/flipkart-icon.45218cd3.svg";